import { getPreferredReferrer } from '../i18n/ReferrerUtils';
import Logger from '../lib/Logger';
import { getQueryParams } from '../routing/getQueryParams';
const TRACK_ENUM = 'TRACK';
const LESSON_ENUM = 'LESSON';
const LOG = Logger.getLogger('academyFormSubmissionUtils');

const maybeLessonId = lessonId => {
  return isNaN(lessonId) ? null : lessonId;
};

const maybeTrackId = (queryParamTrack, trackId) => {
  if (isNaN(trackId)) {
    LOG.warn('TrackId in signup url is not an integer', {
      extra: {
        href: window.location.href,
        referrer: getPreferredReferrer()
      }
    }); // Matches "123/intro"

    const matchShapeTrackIdSubpathIntro = queryParamTrack.match(/^[0-9]+\/intro$/);

    if (matchShapeTrackIdSubpathIntro) {
      const match = matchShapeTrackIdSubpathIntro[0].match(/^[0-9]+/);

      if (match) {
        return parseInt(match[0], 10);
      }
    }

    return null;
  }

  return trackId;
};

export const getTrackId = () => {
  const queryParams = getQueryParams();
  const queryParamTrack = queryParams['track'];

  if (queryParamTrack) {
    return maybeTrackId(queryParamTrack, parseInt(queryParamTrack, 10));
  }

  return null;
};
export const getLessonId = () => {
  const queryParams = getQueryParams();
  const queryParamLesson = queryParams['lesson'];

  if (queryParamLesson) {
    return maybeLessonId(parseInt(queryParamLesson, 10));
  }

  return null;
};
export const getSignupContent = () => {
  const trackId = getTrackId();
  const lessonId = getLessonId();

  if (trackId) {
    return {
      signupContentType: TRACK_ENUM,
      signupContentId: trackId
    };
  }

  if (lessonId) {
    return {
      signupContentType: LESSON_ENUM,
      signupContentId: lessonId
    };
  }

  return {};
};